/* Layouts */
import Layout from '@layouts/layout.vue'
import AboutPage from '@pages/about-page.vue'
import ArticlePage from '@pages/article-page.vue'
import BlogPage from '@pages/blog-page.vue'
import CollectionPage from '@pages/collection-page.vue'
import ContactPage from '@pages/contact-page.vue'
import HomePage from '@pages/home-page.vue'
import PolicyPage from '@pages/legal/PolicyPage.vue'
import MerchItemPage from '@pages/merch-item-page.vue'
import MerchPage from '@pages/merch-page.vue'
import NotFoundPage from '@pages/not-found-page.vue'
import ProductPage from '@pages/product-page.vue'
import ProductsPage from '@pages/products-page.vue'
import StoreLocatorPage from '@pages/store-locator-page.vue'
import WholesalePage from '@pages/wholesale.vue'
import WelcomePage from '@pages/welcome.vue'
import { createRouter, createWebHistory } from 'vue-router'

/* Routes */
const routes = [
	{
		path: '/',
		component: Layout,
		children: [
			{ path: '', name: 'home', component: HomePage },
			{ path: 'contact', name: 'contact', component: ContactPage },
			{ path: 'products', name: 'products', component: ProductsPage },
			{ path: 'product/:slug', name: 'product', component: ProductPage },
			{ path: 'merch', name: 'merch', component: MerchPage },
			{ path: 'wholesale', name: 'wholesale', component: WholesalePage },
			{ path: 'welcome', name: 'welcome', component: WelcomePage },
			{
				path: 'merch/collection/:slug',
				name: 'collection',
				component: CollectionPage,
			},
			{
				path: 'merch/product/:slug',
				name: 'merch-item',
				component: MerchItemPage,
			},
			{ path: 'about', name: 'about', component: AboutPage },
			{ path: 'blog', name: 'blog', component: BlogPage },
			{ path: 'article/:slug', name: 'article', component: ArticlePage },
			{
				path: 'store-locator',
				name: 'store-locator',
				component: StoreLocatorPage,
			},
			{ path: '/page/:slug', name: 'policyPage', component: PolicyPage },
		],
	},
	{ path: '/:pathMatch(.*)*', component: NotFoundPage },
]

const router = createRouter({
	scrollBehavior(to, from, savedPosition) {
		return new Promise((resolve, reject) => {
			setTimeout(() => {
				resolve({ left: 0, top: 0 })
			}, 25)
		})
	},
	history: createWebHistory(),
	routes,
})

export default router
